// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__NDhWB","icon":"style_icon__pYEAv"};